module.exports = __webpack_public_path__ + "static/media/aashay_inamdar.80892c9e.png";